import { render, staticRenderFns } from "./AppAddMinore.vue?vue&type=template&id=8a29e484&"
import script from "./AppAddMinore.vue?vue&type=script&lang=js&"
export * from "./AppAddMinore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports